export default "__VITE_PUBLIC_ASSET__0ed1dd4d__"